module.exports = __webpack_public_path__ + "nc_static/media/collapse.da8b9694.svg";